import React, {memo} from 'react';

import NoResultsMessage from 'app/components/general/NoResultsMessage';
import {gt} from 'app/utils/i18n';

import {DayGroupedTasksList} from '../DayGroupedTasksList';

import type {NotificationType} from 'app/notifly/types';
import type {
  ListResponseType,
  SlimTaskInstanceSerializedType,
} from 'sweet-types';

interface Props {
  tasks: ListResponseType<SlimTaskInstanceSerializedType>;
  userTimezone: string;
  canCreate: boolean;
  showAssignTaskModal: () => void;
  notifications: Record<string, Array<NotificationType>>;
}

export const CompactTasksList = memo<Props>(
  ({
    tasks,
    userTimezone,
    canCreate,
    showAssignTaskModal,
    notifications,
  }: Props) => {
    return (
      <ul className="list-unstyled">
        <div className="row border-top" />
        {tasks.results.length === 0 ? (
          <li>
            <NoResultsMessage head={gt('No tasks found')}>
              {canCreate ? (
                <div>
                  <p>
                    <button
                      className="btn btn-primary btn-lg"
                      onClick={showAssignTaskModal}
                    >
                      {gt('Assign Task')}
                    </button>
                  </p>
                  {gt(
                    'You can also assign tasks from a procedure or process using their "assign" button.'
                  )}
                </div>
              ) : null}
            </NoResultsMessage>
          </li>
        ) : (
          <DayGroupedTasksList
            tasks={tasks.results}
            userTimezone={userTimezone}
            notifications={notifications}
          />
        )}
      </ul>
    );
  }
);
